import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import '../../services/GlobalVariables'
import axios from 'axios'

const API_URL = global.SET_API_URL + 'items/'

const initialState = {
    items: [],
    singleItem: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ""
}

export const addNewItem = createAsyncThunk('itemsInf/ani', async (itemData, thunkAPI) => {
    try {
        console.log('Adding new item with data:', itemData)
        const result = await axios.post(API_URL + 'addNewItem', itemData)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getAllItems = createAsyncThunk('itemsInf/gai', async (_, thunkAPI) => {
    try {
        const result = await axios.get(API_URL + 'getAllItems')
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getItemDetails = createAsyncThunk('itemsInf/gsp', async (itemCode, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'getItemSalesPrice', itemCode)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const deleteItem = createAsyncThunk('itemsInf/di', async (itemCode, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'deleteItem', itemCode)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const itemsInformationSlice = createSlice({
    name: 'menus',
    initialState,
    reducers: {
        reset: (state) => {
            state.items = []
            state.singleItem = []
            state.isLoading = false
            state.isError = false
            state.isSuccess = false
            state.message = ""
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(addNewItem.pending, (state) => {
                state.isLoading = true
            })
            .addCase(addNewItem.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.items.push(action.payload)
            })
            .addCase(addNewItem.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(getAllItems.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getAllItems.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.items = action.payload
            })
            .addCase(getAllItems.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(getItemDetails.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getItemDetails.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.singleItem = action.payload
            })
            .addCase(getItemDetails.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
    }
})

export const { reset } = itemsInformationSlice.actions

export default itemsInformationSlice.reducer